import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { ScrollView } from 'react-native-web-hover';
import { WindowInformation } from '../../../services/window-information';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import FormInput from '../../../components/FormInput';
import { translate } from '../../../services/translate';
import { SectionHeader } from '../../FormCommons';

interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    inViewMode?: boolean;
}

export default function CloudProviderConnectionForm({ form, inViewMode }: Props) {
    const { styles, theme } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    return (<ScrollView contentContainerStyle={[{ flexDirection: 'column', padding: 16, rowGap: 24, backgroundColor: theme.colors.white['500'] }]}>
        <SectionHeader title='connectionInfo'>
            <View style={styles.sectionDisplay(windowInfo.isMobileOrTablet)}>
                <FormInput
                    form={form}
                    fieldName='cloudProviderUsername'
                    label={translate('username')}
                    labelStyle={styles.fieldsLabelStyle}
                    viewStyle={styles.itemView(windowInfo.isMobileOrTablet ? 1 : 4)}
                    disabled={inViewMode}
                />
                <FormInput
                    form={form}
                    fieldName='cloudProviderPassword'
                    label={translate('password')}
                    labelStyle={styles.fieldsLabelStyle}
                    viewStyle={styles.itemView(windowInfo.isMobileOrTablet ? 1 : 4)}
                    disabled={inViewMode}
                />
                <FormInput
                    form={form}
                    fieldName='cloudProviderEndpoint'
                    label={translate('apiAddress')}
                    labelStyle={styles.fieldsLabelStyle}
                    viewStyle={styles.itemView(windowInfo.isMobileOrTablet ? 1 : 4)}
                    disabled={inViewMode}
                />
            </View>
        </SectionHeader>
    </ScrollView>);
}

const styleSheet = createStyleSheet((theme) => ({
    fieldsLabelStyle: {
        color: theme.colors.neutral['500'],
        fontWeight: '600',
        fontSize: 14,
    },
    sectionDisplay: (isSmallView: boolean) => ({
        gap: 16,
        flexDirection: isSmallView ? 'column' : 'row',
    }),
    itemView: (flex: number) => ({
        gap: 8,
        flex
    })
}));
